import { FormField, Select, SelectOption } from "@justworkshr/milo-form";
import { SupportedCountriesContext } from "pages/employer-of-record/contexts/supportedCountriesContext";
import { ChangeEventHandler, FocusEventHandler, useContext } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  value?: string;
  error?: string;
  handleBlur?: FocusEventHandler<HTMLSelectElement>;
  handleChange?: ChangeEventHandler<HTMLSelectElement>;
};

export default function WorkCountrySelectField(props: Props) {
  const { value, error, handleBlur, handleChange } = props;
  const { t } = useTranslation();
  const { supportedCountriesData } = useContext(SupportedCountriesContext);

  const allCountryOptions = Object.values(supportedCountriesData || []).map(
    (country) => ({
      value: country.code,
      description: country.commonName ?? country.code,
    })
  );

  return (
    <FormField
      name="workCountry"
      required
      label={t("Work country")}
      error={error}
    >
      <Select
        required
        name="workCountry"
        placeholder={t("Select country")}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
      >
        {allCountryOptions.map(({ value, description }) => (
          <SelectOption value={value} key={value}>
            {description}
          </SelectOption>
        ))}
      </Select>
    </FormField>
  );
}
